
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [ {
label: '危包规格名称',
value: this.$route.params.DG_NAME
}, {
label: '危包规格简称',
value: this.$route.params.DG_JNAME
}, {
label: '危包规格说明',
value: this.$route.params.DG_Reamrk
}]
console.log(this.$route.params)
}
}



// WEBPACK FOOTER //
// ./src/components/P_DangerousGoodsDetail.vue